/**
 * @return {{feature: string, click: string}}
 */
export const popinBackToSchool = () => ({
  feature: 'popin_rentree',
  click: 'validee',
});
